import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class PermissionManagementService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async GetPermissions(userId: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = `${window.$config.HostName}api/users/${userId}/permissions`;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            this.loaderService.HideLoader();
            return { isSuccess: false, errorMessage: 'Failed to load permissions' };
        }
    }

    public async UpsertPermission(userId: string, screenKey: string, isAllowed?: boolean): Promise<any> {
    this.loaderService.ShowLoader();
    try {
      const url = `${window.$config.HostName}api/users/${userId}/permissions/${encodeURIComponent(screenKey)}`;
      const body = (typeof isAllowed === 'boolean') ? { isAllowed } : {};
      const result = await this.axiosService.axiosInstance.put(url, body);
      this.loaderService.HideLoader();
      return result.data; 
    } catch (e) {
      this.loaderService.HideLoader();
      return { isSuccess: false, errorMessage: `Failed to update ${screenKey}` };
    }
  }

}
